export default __webpack_public_path__ + "static/media/multicar5.888e6d45.jpeg";